export default file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = () => {
      reject("Error reading file");
    };
    reader.onabort = () => {
      reject("Reading operation is aborted");
    };
    reader.readAsDataURL(file);
  });



// WEBPACK FOOTER //
// ./src/core/utils/readFile.js